






















import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class NotificationHandler extends Vue {
  @Prop({ default: 0 }) private unreadMessagesCount!: number;
  @Prop() isNotifyPanelShow!: boolean;

  get count(): string {
    return this.unreadMessagesCount > 99 ? '99+' : `${this.unreadMessagesCount}`;
  }

  @Emit('toggleNotifications') toggleNotifications(): void { return; }
}
